import { TenantConfig } from "../tenant.model";

export const tenant: TenantConfig = {
  tenandId: 'nexa',
  brandName: 'Nexa',
  brandLogoImage: null,
  favicon: 'default-favicon.ico',
  showSupplierLogo: false,
  apiUrl: 'https://api.nexa.test.assistant.beta80group.it',
  apiUrlProd: '',
  navigationItems: [
        { label: 'Home', route: '/overview', group: 'settings' },
        { label: 'Statistiche', route: '/statistiche', group: 'navigation', featureName: 'statistics' },
        { label: 'Documenti', route: '/documenti', group: 'navigation', featureName: 'document' },
        { label: 'Links', route: '/ingestion-link', group: 'navigation', featureName: 'ingestion-link' },
        { label: 'Conversazioni', route: '/conversazioni', group: 'navigation', featureName: 'conversations' },
        { label: 'Valutazioni', route: '/valutazioni', group: 'navigation', featureName: 'feedback' },
        { label: 'Ricerca Chunks', route: '/chunks', group: 'navigation', featureName: 'chunk' },
        { label: 'Permessi', route: '/permessi', group: 'navigation', featureName: 'permissions', requiresAdmin: true },
        { label: 'Impostazioni', route: '/impostazioni', group: 'navigation', featureName: 'settings', requiresAdmin: true },
    ],
  apiEndpoints: {
    document: '/document',
    assistant: '/assistant',
  },
  documentiApi: '/document',
  samlProviderName: 'assistant-external-idp',
  samlProviderNameProd: 'assistant-external-idp',
  samlEnabled: false,
  chatConfig: {
    // TRUE = Scarica da CloudFront oppure FALSE = Usa il file nexa-chat.bundle.js presente nella cartella del componente
    useRemoteLoader: true,
    remoteTestUrl: 'https://d3so8u9uewocbp.cloudfront.net/bundle/nexa-chat.bundle.js',
    remoteProdUrl: 'https://d11zdqjy12f21w.cloudfront.net/bundle/nexa-chat.bundle.js',
    bundleFile: 'nexa-chat.bundle.js',
    elementTag: 'nexa-chat',
    assistantName: 'NEXA',
    assistantImage: 'bot-icon',
    envConfig: {
      uat: { apiEndpoint: 'https://api.nexa.test.assistant.beta80group.it' },
      prod: { apiEndpoint: 'https://api.nexa.assistant.beta80group.it' },
    },
  },
  amplifyConfig: {
    nativeAuth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_lxxZ1zLrJ',
      userPoolWebClientId: '4cuvukn07bq0ku3ukuf8ror87q',
      mandatorySignIn: false,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      oauth: {
        domain: 'eu-central-1lxxz1zlrj.auth.eu-central-1.amazoncognito.com',
        scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
        redirectSignIn: 'https://www.nexa.test.assistant.beta80group.it/',
        redirectSignOut: 'https://www.nexa.test.assistant.beta80group.it/login-admin',
        responseType: 'code',
      },
    },
    nativeAuthProd: {
      region: 'eu-central-1',
      userPoolId: '',
      userPoolWebClientId: '',
      mandatorySignIn: false,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      oauth: {
        domain: '',
        scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
        redirectSignIn: '',
        redirectSignOut: '',
        responseType: 'code',
      },
    },
  },
  theme: {
    semantic: {
      primary: {
        50: '#e6f0f3',
        100: '#b3d1d9',
        200: '#80b2bf',
        300: '#4d93a5',
        400: '#1a748b',
        500: '#003B55',
        600: '#002f44',
        700: '#002333',
        800: '#001722',
        900: '#000b11',
        950: '#000508',
      },
      danger: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#74262B',
        600: '#5e1e22',
        700: '#4a181c',
        800: '#371215',
        900: '#240c0e',
        950: '#180809',
      },
      secondary: {
        50: '#f5f5f5',
        100: '#e5e5e5',
        200: '#cccccc',
        300: '#b3b3b3',
        400: '#999999',
        500: '#555555',
        600: '#444444',
        700: '#333333',
        800: '#222222',
        900: '#111111',
        950: '#0a0a0a',
      },
      formField: {
        borderRadius: '4px',
        paddingX: '12px',
        paddingY: '12px',
        borderWidth: '2px',
      },
    },
    form: {
      iconColor: '#003B55',
    },
    components: {
      datatable: {
        headerCell: {
          background: '#e6f0f3'
        }
      },
      card: {
        body: {
          padding: '0',
        }
      },
      dialog: {
        header: {
          padding: '32px 32px 0 32px',
        },
        content: {
          padding: '32px',
        },
        footer: {
          padding: '0 32px 32px 32px',
        }
      },
    }
  },
};
